import { render, staticRenderFns } from "./CreatePolicy.vue?vue&type=template&id=543bf6fc&"
import script from "./CreatePolicy.vue?vue&type=script&lang=js&"
export * from "./CreatePolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports